// 公共接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi} = apiPrefix;

// 获取坐席信息
export const getQueryAgent = (params) => {
  return get(apiPrefix.baseApi + '/callRecord/queryAgent', params);
}

export const getQueryMenus = (params) => {
  return get(apiPrefix.baseApi + '/user/queryMenus', params);
}

// 获取打卡信息
export const getClockInStatus = (params) => get(`${baseApi}/jobOrder/checkWorkHour`, params);
// 打卡
export const clockIn = (params) => post(`${baseApi}/jobOrder/workHour`, params);

// 获取公众号未回复数量
export const getWxGzhUnRead = (params={}) => {
  params = {
    seatId: (JSON.parse(localStorage.getItem("userInfo")) || {}).id,
  }
  return get(`${baseApi}/weChatApi/getUnReadCusNum`, params);
}